import { render, staticRenderFns } from "./data4.vue?vue&type=template&id=24764244"
import script from "./data4.vue?vue&type=script&lang=js"
export * from "./data4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports